<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/HluzLz/tc-custom/9780062351951.jpg?1719976422300" alt="This image is the cover for the book Midnight in Broad Daylight"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Midnight in Broad Daylight
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Meticulously researched and beautifully written, the true story of a Japanese American family that found itself on opposite sides during World War II—an epic tale of family, separation, divided loyalties, love, reconciliation, loss, and redemption—and a riveting chronicle of U.S.–Japan relations and the Japanese experience in America</b></p><p>After their father’s death, Harry, Frank, and Pierce Fukuhara—all born and raised in the Pacific Northwest—moved to Hiroshima, their mother’s ancestral home. Eager to go back to America, Harry returned in the late 1930s. Then came Pearl Harbor. Harry was sent to an internment camp until a call came for Japanese translators and he dutifully volunteered to serve his country. Back in Hiroshima, his brothers Frank and Pierce became soldiers in the Japanese Imperial Army.</p><p>As the war raged on, Harry, one of the finest bilingual interpreters in the United States Army, island-hopped across the Pacific, moving ever closer to the enemy—and to his younger brothers. But before the Fukuharas would have to face each other in battle, the U.S. detonated the atomic bomb over Hiroshima, gravely injuring tens of thousands of civilians, including members of their family.</p><p>Alternating between the American and Japanese perspectives, <i>Midnight in Broad Daylight</i> captures the uncertainty and intensity of those charged with the fighting as well as the deteriorating home front of Hiroshima—as never told before in English—and provides a fresh look at the dropping of the first atomic bomb. Intimate and evocative, it is an indelible portrait of a resilient family, a scathing examination of racism and xenophobia, an homage to the tremendous Japanese American contribution to the American war effort, and an invaluable addition to the historical record of this extraordinary time.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Pamela Rotner Sakamoto
      </h2>
      
      <p class="authorDescription body article"><P>Pamela Rotner Sakamoto is an &#160;American historian. Fluent in Japanese, she lived in Kyoto and Tokyo for seventeen years. She works as an expert consultant on Japan-related projects for the United States Holocaust Memorial Museum in Washington, D.C., and has taught in the University of Hawaii system. She is on the faculty at Punahou School in Honolulu.</P><P></P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      HarperCollinsPublishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4b1efffa